import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../features/login/loginSlice";

const store = configureStore({
  reducer: {
    loginData: loginSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
